export const StripeGroupsErrors = {
  unknown: [
    'fraudulent',
    'stolen_card',
    'generic_decline',
    'do_not_try_again',
    'do_not_honor',
    'call_issuer',
    'no_action_taken',
    'merchant_blacklist',
    'lost_card',
    'service_not_allowed',
    'security_violation',
    'revocation_of_authorization',
    'revocation_of_all_authorizations',
    'restricted_card',
    'reenter_transaction',
    'try_again_later',
    'transaction_not_allowed',
    'stop_payment_order',
    'account_country_invalid_address',
    'account_error_country_change_requires_additional_steps',
    'account_invalid',
    'account_number_invalid',
    'acss_debit_session_incomplete',
    'alipay_upgrade_required',
    'amount_too_large',
    'amount_too_small',
    'api_key_expired',
    'balance_insufficient',
    'bank_account_declined',
    'bank_account_exists',
    'bank_account_unusable',
    'bank_account_unverified',
    'bank_account_verification_failed',
    'billing_invalid_mandate',
    'bitcoin_upgrade_required',
    'card_decline_rate_limit_exceeded',
    'cardholder_phone_number_required',
    'charge_already_captured',
    'charge_already_refunded',
    'charge_disputed',
    'charge_exceeds_source_limit',
    'charge_expired_for_capture',
    'charge_invalid_parameter',
    'clearing_code_unsupported',
    'country_code_invalid',
    'country_unsupported',
    'coupon_expired',
    'customer_max_payment_methods',
    'customer_max_subscriptions',
    'debit_not_authorized',
    'email_invalid',
    'idempotency_key_in_use',
    'incorrect_address',
    'instant_payouts_limit_exceeded',
    'instant_payouts_unsupported',
    'intent_invalid_state',
    'intent_verification_method_missing',
    'invalid_card_type',
    'invalid_characters',
    'invalid_charge_amount',
    'invalid_expiry_month',
    'invalid_source_usage',
    'invoice_no_customer_line_items',
    'invoice_no_payment_method_types',
    'invoice_no_subscription_line_items',
    'invoice_not_editable',
    'invoice_on_behalf_of_not_editable',
    'invoice_payment_intent_requires_action',
    'invoice_upcoming_none',
    'livemode_mismatch',
    'lock_timeout',
    'missing',
    'no_account',
    'not_allowed_on_standard_account',
    'out_of_inventory',
    'parameter_invalid_empty',
    'parameter_invalid_integer',
    'parameter_invalid_string_blank',
    'parameter_invalid_string_empty',
    'parameter_missing',
    'parameter_unknown',
    'parameters_exclusive',
    'payment_intent_action_required',
    'payment_intent_authentication_failure',
    'payment_intent_incompatible_payment_method',
    'payment_intent_invalid_parameter',
    'payment_intent_konbini_rejected_confirmation_number',
    'payment_intent_mandate_invalid',
    'payment_intent_payment_attempt_expired',
    'payment_intent_payment_attempt_failed',
    'payment_intent_unexpected_state',
    'payment_method_bank_account_already_verified',
    'payment_method_bank_account_blocked',
    'payment_method_billing_details_address_missing',
    'payment_method_currency_mismatch',
    'payment_method_invalid_parameter',
    'payment_method_invalid_parameter_testmode',
    'payment_method_microdeposit_failed',
    'payment_method_microdeposit_verification_amounts_invalid',
    'payment_method_microdeposit_verification_amounts_mismatch',
    'payment_method_microdeposit_verification_attempts_exceeded',
    'payment_method_microdeposit_verification_descriptor_code_mismatch',
    'payment_method_microdeposit_verification_timeout',
    'payment_method_provider_decline',
    'payment_method_provider_timeout',
    'payment_method_unactivated',
    'payment_method_unexpected_state',
    'payment_method_unsupported_type',
    'payouts_not_allowed',
    'platform_account_required',
    'platform_api_key_expired',
    'postal_code_invalid',
    'product_inactive',
    'rate_limit',
    'refer_to_customer',
    'refund_disputed_payment',
    'resource_already_exists',
    'resource_missing',
    'return_intent_already_processed',
    'routing_number_invalid',
    'secret_key_required',
    'sepa_unsupported_account',
    'setup_attempt_failed',
    'setup_intent_authentication_failure',
    'setup_intent_invalid_parameter',
    'setup_intent_setup_attempt_expired',
    'setup_intent_unexpected_state',
    'shipping_calculation_failed',
    'sku_inactive',
    'state_unsupported',
    'tax_id_invalid',
    'taxes_calculation_failed',
    'terminal_location_country_unsupported',
    'testmode_charges_only',
    'tls_version_unsupported',
    'token_already_used',
    'token_in_use',
    'transfers_not_allowed',
    'url_invalid',
  ],

  lack_of_pin: ['online_or_offline_pin_required', 'offline_pin_required'],

  invalid_account: ['new_account_information_available', 'invalid_account'],
};
